import React from 'react';

function NoAccessRights() {
  return <div>You don't have access.</div>;
}

export default NoAccessRights;
